import React, {useContext, useEffect, useState} from "react";
import {ITogglePlugin, PluginType} from "../Hooks/useScripts";
import {SearchPanelDropdownOption} from "../Components/SearchPanel";
import CircleLoader from "../Components/CircleLoader";
import {IDropdownOption} from "../Components/Dropdown";
import {Scrollbars} from "rc-scrollbars";
import {useTranslation} from "react-i18next";
import PluginItem from "../Components/Plugins/PluginItem";
import {Input} from "semantic-ui-react";
import {NavLink, useParams} from "react-router-dom";
import keys from "../translations/keys";
import {DataContext} from "../Context/DataContext";

const PublicPluginsPage = () => {
    let {id} = useParams<{ id: string | undefined }>();
    const {isLoading: isMainDataLoading, isPluginsLoaded, pluginToggleGetDtos} = useContext(DataContext);
    const [plugins, setPlugins] = useState([] as ITogglePlugin[])
    const [search, setSearch] = useState('')
    const [selectedFilter, setSelectedFilter] = useState(undefined as IDropdownOption | undefined)
    const {t} = useTranslation();
    const isLoading = isMainDataLoading || !isPluginsLoaded

    useEffect(() => {
        setPlugins(pluginToggleGetDtos)
    }, [pluginToggleGetDtos])


    const checkType = (pluginType: PluginType) => {
        if (!selectedFilter)
            return true;
        switch (selectedFilter.id as SearchPanelDropdownOption) {
            case SearchPanelDropdownOption.All:
                return true;
            case SearchPanelDropdownOption.Hero:
                return pluginType === PluginType.Hero
            case SearchPanelDropdownOption.Utility:
                return pluginType === PluginType.Utility
            case SearchPanelDropdownOption.Library:
                return pluginType === PluginType.Library
        }
    }

    const getFilteredData = plugins && plugins
        .filter((x) => (
            !!id && x.id === parseInt(id!))
            || (!id && x.pluginName.toLowerCase().indexOf(search.toLowerCase()) >= 0 && checkType(x.type)));

    return (
        <div className="public-plugins-page">
            <div className="left-panel">
                {/*<SearchPanel search={search} setSearch={setSearch} setSelectedFilter={setSelectedFilter}/>*/}
                <Input value={search} icon='search' placeholder='Search...'
                       onChange={(event, data) => setSearch(data.value)}/>
                <NavLink className="link" exact to='/plugins'>{t(keys.lefPanel.dashboard.plugins)}</NavLink>
            </div>
            <Scrollbars autoHide hideTracksWhenNotNeeded disableDefaultStyles>
                <div className="content">
                    <CircleLoader isLoading={isLoading}/>
                    {/*{!isLoading && getFilteredData.length === 0 && <div className="no-data">Нет данных</div>}*/}
                    {getFilteredData.map((plugin: ITogglePlugin, index) => {
                        return <PluginItem plugin={plugin}
                                           key={index}/>
                    })}
                </div>
            </Scrollbars>
        </div>)
}

export default PublicPluginsPage;
